import { getEco } from "../../repository/eco-backend";

export const getAdviceById = async (id) => {
  const response = await getEco(`advice/${id}`);

  return response;
};
